var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"about-video content-section container px-3"},[_c('h2',{staticClass:"content-section-title"},[_vm._v(_vm._s(_vm.info.title))]),_c('VideoPlayer',{attrs:{"videos":_vm.info.videos}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }